<template>
    <div class="service-details ptb-100">
        <div class="container">
            <div class="service-details-content">
                <h3 data-aos="fade-up" data-aos-once="true">Die richtige Entscheidung treffen</h3>

                <p data-aos="fade-up" data-aos-delay="100" data-aos-once="true">Sie haben eine Idee, ein Problem oder ein Projekt - aber wissen nicht, wo Sie anfangen sollen? Welche Technologie ist die richtige? Was ist realistisch umsetzbar? Was kostet es wirklich? Wir helfen Ihnen, die richtigen Entscheidungen zu treffen, bevor Sie investieren.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-delay="0" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-bulb'></i>
                            </div>
                            <h3>Ideenvalidierung</h3>
                            <p>Ist Ihre Idee technisch machbar? Was braucht es dafür? Gemeinsam prüfen wir Ihre Vision auf Herz und Nieren.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-delay="100" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-git-compare'></i>
                            </div>
                            <h3>Technologievergleich</h3>
                            <p>React oder Vue? Node.js oder Python? Wir erklären die Vor- und Nachteile verständlich und empfehlen die beste Lösung für Ihr Projekt.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-right" data-aos-delay="200" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-euro'></i>
                            </div>
                            <h3>Kostenschätzung</h3>
                            <p>Realistische Einschätzung, was Ihr Projekt kostet. Keine bösen Überraschungen, keine versteckten Kosten.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="fade-left" data-aos-delay="300" data-aos-once="true">
                        <div class="single-features-box">
                            <div class="icon">
                                <i class='bx bx-map-alt'></i>
                            </div>
                            <h3>Projektplanung</h3>
                            <p>Roadmap für Ihr Projekt. Welche Schritte, in welcher Reihenfolge, mit welchen Meilensteinen.</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Typische Fragen, die ich beantworte</h4>

                <ul class="features-list mb-4" data-aos="fade-up" data-aos-delay="100" data-aos-once="true">
                    <li><i class='bx bx-check'></i> <strong>"Brauche ich eine App oder reicht eine Webseite?"</strong> - Oft ist eine responsive Webanwendung günstiger und ausreichend</li>
                    <li><i class='bx bx-check'></i> <strong>"Welche Technologie ist die richtige?"</strong> - Abhängig von Ihren Anforderungen, Skalierbarkeit und Budget</li>
                    <li><i class='bx bx-check'></i> <strong>"Wie integriere ich bestehende Systeme?"</strong> - APIs und Schnittstellen verständlich erklärt</li>
                    <li><i class='bx bx-check'></i> <strong>"Was braucht mein Projekt wirklich?"</strong> - Oft weniger als Sie denken</li>
                    <li><i class='bx bx-check'></i> <strong>"Wie finde ich einen guten Entwickler?"</strong> - Worauf Sie achten sollten, auch wenn Sie nicht mich beauftragen</li>
                </ul>

                <h4 data-aos="fade-up" data-aos-once="true">Ehrliche Beratung - auch wenn es nicht zu einem Auftrag führt</h4>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-once="true">Mein Ziel ist es, Ihnen zu helfen - nicht, Ihnen etwas zu verkaufen. Wenn Ihr Projekt zu groß für einen Einzelunternehmer ist, sage ich Ihnen das. Wenn eine fertige Lösung günstiger ist als Eigenentwicklung, empfehle ich sie. Wenn Ihre Idee technisch nicht sinnvoll ist, erkläre ich warum und zeige Alternativen.</p>

                <div class="row mt-4 mb-4">
                    <div class="col-lg-6 col-md-6" data-aos="zoom-in" data-aos-delay="0" data-aos-once="true">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-time-five'></i>
                            <h3>60 Min</h3>
                            <p>Kostenloses Erstgespräch ohne Verpflichtung</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6" data-aos="zoom-in" data-aos-delay="100" data-aos-once="true">
                        <div class="single-funfacts funfact-style-two">
                            <i class='bx bx-file'></i>
                            <h3>Dokumentiert</h3>
                            <p>Sie erhalten eine schriftliche Zusammenfassung</p>
                        </div>
                    </div>
                </div>

                <h4 data-aos="fade-up" data-aos-once="true">Für wen ist IT-Beratung sinnvoll?</h4>
                <p data-aos="fade-up" data-aos-delay="100" data-aos-once="true">Besonders für kleine Unternehmen und Selbständige, die keine eigene IT-Abteilung haben. Bevor Sie tausende Euro in ein Projekt investieren, lohnt sich ein Gespräch mit jemandem, der die technischen Möglichkeiten kennt - und Ihnen ehrlich sagt, was Sinn macht und was nicht.</p>

                <div class="service-cta mt-5" data-aos="fade-up" data-aos-delay="200" data-aos-once="true">
                    <h4>Lassen Sie uns über Ihr Projekt sprechen</h4>
                    <p>Das Erstgespräch ist kostenlos und unverbindlich. Danach wissen Sie, ob und wie ich Ihnen helfen kann.</p>
                    <router-link to="/contact" class="default-btn">
                        <i class='bx bxs-paper-plane'></i>
                        Kostenloses Erstgespräch buchen
                        <span></span>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ItBeratungDetails'
}
</script>
